import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Login from "./pages/Login";
import LandingPage from "./pages/LandingPage";
import UsersPage from "./pages/UsersPage";
import "./App.css";

function AuthGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  React.useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!token && location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }
  }, [location, navigate]);
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AuthGuard>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <LandingPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <UsersPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </AuthGuard>
      </Router>
    </AuthProvider>
  );
}

export default App;
